import getSymbolFromCurrency from 'currency-symbol-map';
import { PRODUCTS, SUBSCRIPTION_PERIOD } from '../constants/config';

const extractPlansDataFromOrder = (order) => {
  if (!order) return;

  const getPriceByPlanPath = (path) =>
    (order.groups[0].items.find((p) => p.path === path) || {}).priceValue;

  return {
    getPrice(plan) {
      const monthlyPrice = getPriceByPlanPath(plan.paymentPlanPaths[SUBSCRIPTION_PERIOD.MONTHLY]);
      const yearlyPrice = getPriceByPlanPath(plan.paymentPlanPaths[SUBSCRIPTION_PERIOD.YEARLY]);
      const lifetimePrice = getPriceByPlanPath(plan.paymentPlanPaths[SUBSCRIPTION_PERIOD.LIFETIME]);
      const yearlyMonthlyPrice = yearlyPrice && Math.floor((yearlyPrice / 12) * 100) / 100;

      return {
        monthlyPrice,
        yearlyMonthlyPrice,
        lifetimePrice,
        currencySymbol: getSymbolFromCurrency(order.currency),
      };
    },
  };
};

export const getPlansPrices = () => {
  return new Promise((resolve) => {
    if (window.fastspringOrderData) return resolve(window.fastspringOrderData);
    window.addEventListener('fastspringOrderDataUpdate', ({ detail: order }) => resolve(order));
  }).then(extractPlansDataFromOrder);
};
